import { lazy, Suspense } from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'
import { LoadingState } from './ui'

/**
 * Two route trees in one application (`ADR-028`), code-split so a participant never downloads
 * admin code.
 *
 * `/p/:token` is **retained as a redirect**. Magic links are excluded from Phase 1 (S1 §31) and
 * there is no token to claim any more, but that URL was emailed to real participants before this
 * change. Sending them to the sign-in page is far better than a blank screen: their invitation
 * now carries a Participant ID and password, and this is where they use them.
 *
 * The admin tree is mounted on a splat and does its own routing inside `AdminApp`, because every
 * admin screen sits inside the same authenticated shell — hoisting those routes up here would
 * mean re-deciding "is there a session?" at each one.
 */
const AdminApp = lazy(() => import('./admin/AdminApp'))
const ParticipantApp = lazy(() => import('./participant/ParticipantApp'))

function Loading() {
  return (
    <div className="aurora page-splash">
      <LoadingState />
    </div>
  )
}

export const router = createBrowserRouter([
  { path: '/', element: <Navigate to="/admin/projects" replace /> },
  {
    path: '/admin/*',
    element: (
      <Suspense fallback={<Loading />}>
        <AdminApp />
      </Suspense>
    ),
  },
  { path: '/p/:token', element: <Navigate to="/participant" replace /> },
  { path: '/p', element: <Navigate to="/participant" replace /> },
  {
    path: '/participant/*',
    element: (
      <Suspense fallback={<Loading />}>
        <ParticipantApp />
      </Suspense>
    ),
  },
])
